import * as SheetPrimitive from "@radix-ui/react-dialog";

export const SheetPortal = SheetPrimitive.Portal;

SheetPortal.displayName = SheetPrimitive.Portal.displayName;
